import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';
import { ById } from '../services/backendService/types';

export const testcasesCacheKey = 'testcases';
const useTestcases = ({ presentationId }: { presentationId?: string }) => {
  const { data: testcases, isFetching: isFetchingTestcases } = useQuery(
    [testcasesCacheKey, presentationId],
    async () => {
      if (!presentationId) return Promise.resolve(undefined);
      return BackendService.instance.ai.getTestcases({ presentationId });
    },
    {
      enabled: Boolean(presentationId),
      staleTime: 1000 * 60 * 5,
      retry: false,
    },
  );

  return {
    testcases,
    isFetchingTestcases,
  };
};

export default useTestcases;
